module.exports = __webpack_public_path__ + "6ef0feca90b413988172019af8a2f55d.jpg";